"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFocusTrap = void 0;
var react_1 = require("react");
var focus_manager_1 = require("./focus-manager");
var tabbable_1 = require("./tabbable");
var scope_tab_1 = require("./scope-tab");
var create_aria_hider_1 = require("./create-aria-hider");
function useFocusTrap(active) {
    if (active === void 0) { active = true; }
    var ref = react_1.useRef();
    var restoreAria = react_1.useRef(null);
    var setRef = react_1.useCallback(function (node) {
        if (restoreAria.current) {
            restoreAria.current();
        }
        if (ref.current) {
            focus_manager_1.returnFocus();
            focus_manager_1.teardownScopedFocus();
        }
        if (active && node) {
            focus_manager_1.setupScopedFocus(node);
            focus_manager_1.markForFocusLater();
            var processNode_1 = function (_node) {
                restoreAria.current = create_aria_hider_1.createAriaHider(_node);
                var focusElement = null;
                if (!focusElement) {
                    var children = Array.from(node.querySelectorAll(tabbable_1.FOCUS_SELECTOR));
                    focusElement = children.find(tabbable_1.tabbable) || children.find(tabbable_1.focusable) || null;
                    if (!focusElement && tabbable_1.focusable(node))
                        focusElement = node;
                }
                if (focusElement) {
                    focusElement.focus();
                }
                else if (process.env.NODE_ENV === 'development') {
                    // eslint-disable-next-line no-console
                    console.warn('[@mantine/hooks/use-focus-trap] Failed to find focusable element within provided node', node);
                }
            };
            // Delay processing the HTML node by a frame. This ensures focus is assigned correctly.
            setTimeout(function () {
                if (node.ownerDocument) {
                    processNode_1(node);
                }
                else if (process.env.NODE_ENV === 'development') {
                    // eslint-disable-next-line no-console
                    console.warn('[@mantine/hooks/use-focus-trap] Ref node is not part of the dom', node);
                }
            });
            ref.current = node;
        }
        else {
            ref.current = null;
        }
    }, [active]);
    react_1.useEffect(function () {
        if (!active)
            return undefined;
        var handleKeyDown = function (event) {
            if (event.key === 'Tab' && ref.current) {
                scope_tab_1.scopeTab(ref.current, event);
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return function () {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [active]);
    return setRef;
}
exports.useFocusTrap = useFocusTrap;
